import { Controller } from "stimulus";

/* Shows the modal with spiff information to the merchant
 * based on their settings and trigger Funfetti when we close it
 */

export default class extends Controller {
  connect() {
    this.showModal();
  }

  showModal() {
    this.element.classList.remove("hidden");
  }

  closeModal() {
    this.element.classList.add("hidden");

    /* the listener is defined on the funfetti_controller.js */
    const event = new CustomEvent("show-funfetti", {
      detail: { check: "true" },
      bubbles: true,
      cancelable: true
    });
    this.element.dispatchEvent(event)
  }
}
